<template>
    <div class="dialog-inner" style="padding-top:0;">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" :show-message="true" class="form-col2">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="宿舍类型" prop="roomType">
                        <el-select
                            v-model="form.roomType"
                            placeholder="请选择"
                            size="small"
                            style="width:100%;">
                            <el-option
                                v-for="item in roomTypeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="可住人数" prop="checkinNum">
                        <el-select
                            v-model="form.checkinNum"
                            placeholder="请选择"
                            size="small"
                            style="width:100%;">
                            <el-option
                                v-for="item in checkinNumList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="费用类型" prop="costTypeId">
                        <el-select
                            v-model="form.costTypeId"
                            placeholder="请选择"
                            size="small"
                            clearable
                            filterable
                            style="width:100%;">
                            <el-option
                                v-for="item in costTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="submit-row">
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" :loading="submitting" size="small">提交</el-button>
                        <el-button @click="resetForm" size="small">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import http from "@/utils/http"
import common from "@/utils/common"
import verify from "@/utils/verify"

export default {
    name: 'BuildingRoomBatchEdit',
    components: {

    },
    props: {
        params: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data(){
        return {
            checkinNumList: [],
            roomTypeList: [],
            costTypeList: [],
            // propertyList: [
            //     {
            //         value: 1,
            //         name: '空调',
            //     },
            //     {
            //         value: 2,
            //         name: '架子床',
            //     },
            //     {
            //         value: 3,
            //         name: '柜子',
            //     },
            // ],
            form: {
                idList: [],
                costTypeId: '',
                roomType: '',
                checkinNum: '',
            },
            rules: {
                roomType: [{required: true, message: '宿舍类型不能为空', trigger: 'change'}],
                // property: [{required: true, message: '宿舍资产不能为空', trigger: 'change'}],
                checkinNum: [{required: true, message: '可住人数不能为空', trigger: 'change'}],
            },
            submitting: false
        }
    },
    created() {
        this.loadRoomTypeList();
        this.loadCostTypeList();
        this.init();
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
    methods: {
        ...common,
        ...verify,
        init() {
            let data = {
                idList: this.params.idList,
                costTypeId: '',
                roomType: '',
                checkinNum: '',
            };

            this.form = data;
            this.setNumList();
        },
        setNumList(){
            this.checkinNumList = [];
            for(let i = 1; i <= 20; i++){
                this.checkinNumList.push({
                    value: i,
                    name: i + '人',
                });
            }
        },
        loadRoomTypeList(){
            http.get('v1/buildType/list', { params: { status: 1 } }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    let roomTypeList = []
                    req.data.data.forEach(x => {
                        roomTypeList.push({
                            value: x.id,
                            name: x.name,
                        });
                    });
                    this.roomTypeList = roomTypeList;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.submitting = false;
                this.httpCatch(err);
            });
        },
        loadCostTypeList(){
            http.get('v1/buildGood/list', { params: { status: 1 } }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.costTypeList = req.data.data;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.submitting = false;
                this.httpCatch(err);
            });
        },
        handleSubmit(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    http.post('v1/build/batchEdit', this.form).then(req => {
                        this.submitting = false;
                        if (req.data.code == http.SUCCESS) {
                            this.showSuccess('批量编辑房间成功', () => {
                                this.$emit('done');
                            });
                        } else {
                            this.showError(req.data.msg);
                        }
                    }).catch(err => {
                        this.tableLoading = false;
                        this.httpCatch(err);
                    });
                } else {
                    return false;
                }
            });
        },
    }
};
</script>

<style scoped>
</style>
